export default "__VITE_ASSET__D8X9uwe___"